import { render, staticRenderFns } from "./SelectChatParticipantsModal.vue?vue&type=template&id=475a446c&scoped=true&"
import script from "./SelectChatParticipantsModal.vue?vue&type=script&lang=js&"
export * from "./SelectChatParticipantsModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectChatParticipantsModal.vue?vue&type=style&index=0&id=475a446c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475a446c",
  null
  
)

export default component.exports